import { Helmet } from 'react-helmet-async';
import React from 'react';
import OrganizationContainer from '../../containers/organizations/OrganizationDetailContainer.jsx';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import NotificationContainer from '../../containers/notification/NotificationsContainer.jsx';

const ShowOrganization = () => (
  <>
    <Helmet>
      <title>Organization | ChangeSync</title>
    </Helmet>
    <OrganizationContainer />
    <NotificationContainer />
  </>
);

export default requireAuth(withRouterParams(ShowOrganization));
